import { render, staticRenderFns } from "./CallInfo.vue?vue&type=template&id=75606eda&scoped=true"
import script from "./CallInfo.vue?vue&type=script&lang=js"
export * from "./CallInfo.vue?vue&type=script&lang=js"
import style0 from "./CallInfo.vue?vue&type=style&index=0&id=75606eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75606eda",
  null
  
)

export default component.exports